/**
 * 由于后端返回的资源路径是相对于$imgBaseSrc的路径
 * 如果带 http 或 https 前缀的资源，则使用绝对路径
 * @param {string} src 资源路径
 */
export default function (src) {
  if (!src) {
    return ''
  }
  return typeof src === 'string' ? (src.indexOf('http') > -1 ? src : window.$imgBaseSrc + src) : null
}
